import styled from 'styled-components';

import { ButtonSquare } from '@xsolla/ui-core';

export const StyledButtonSquare = styled(ButtonSquare)`
  margin-left: 8px;
`;
